import { useState } from "react";
import Button from "../Button/Button";
import styled from "styled-components";
import { AddNoteModal } from "../Dialog/AddNoteModal";
const initvaluemodal = {
  AddNoteModal: false,
};
export const Collapce = ({
  children,
  closebutton,
  title,
  button,
  hasModal,
  payload,
}) => {
  const [collapce, setCollapce] = useState(false);
  const [show, setShow] = useState(initvaluemodal);
  return (
    <CollapseWrapper>
      <TitleWrapper>
        <h6 onClick={() => setCollapce(!collapce)}>{title}</h6>
      </TitleWrapper>
      <div className="content">
        {collapce ? (
          <div className="Wrapper">
            <div className="w-100 children">{children}</div>
            <div className="d-flex justify-content-end">
              {button ? (
                <Button
                  style={{ marginLeft: "10px" }}
                  onclick={() => setShow({ ...show, AddNoteModal: true })}
                  small={"small"}
                  bgColor={"#009ef7"}
                  color={"#fff"}
                  size="12px"
                >
                  افزودن یادداشت
                </Button>
              ) : null}
              {closebutton ? (
                <Button
                  onclick={() => setCollapce(!collapce)}
                  small={"small"}
                  bgColor={"#f1416c"}
                  color={"#fff"}
                  size="12px"
                >
                  بستن
                </Button>
              ) : null}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {hasModal ? (
        <AddNoteModal
          handleClose={() => setShow({ ...show, AddNoteModal: false })}
          show={show.AddNoteModal}
          userdata={payload}
        />
      ) : null}
    </CollapseWrapper>
  );
};

export const TitleWrapper = styled.div`
  h6 {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    background-color: ${({ theme }) => theme.box};
    align-items: center;
    height: 30px;
    box-shadow: ${({ theme }) => theme.boxShadow};
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 0px;
  }
`;
export const CollapseWrapper = styled.div`
  padding: 5px;
  margin-bottom: 1rem;
  .Wrapper {
    border: 1px solid #ddd;
    padding: 5px;
  }
`;
